// @ts-check
import React from "react"
import { Image } from "primereact/image"
import { isFileUIPart } from "ai"
import { clsx } from "../../../../../utils/strings.utils"
import { isPdfMediaType } from "./estimationAgentAttachments.constants"

/**
 * @param {{ parts: import("ai").UIMessage["parts"] }} props
 */
export default function UserMessageFileParts({ parts }) {
  if (!parts?.length) return null
  const files = parts.filter(
    (p) => isFileUIPart(/** @type {any} */ (p))
  )
  if (files.length === 0) return null

  return (
    <div className="estimation-agent-quick-v3__message-files">
      {files.map((part, idx) => {
        const p = /** @type {import("ai").FileUIPart} */ (part)
        const url = p.url
        const name = p.filename ?? "archivo"
        const pdf = isPdfMediaType(p.mediaType)

        if (pdf) {
          return (
            <div
              key={`msg-file-${idx}-${url}`}
              className={clsx(
                "estimation-agent-quick-v3__file-tile",
                "estimation-agent-quick-v3__file-tile--pdf"
              )}
            >
              <div className="estimation-agent-quick-v3__file-tile-pdf-head">
                <span className="estimation-agent-quick-v3__file-tile-name">
                  {name}
                </span>
              </div>
              <button
                type="button"
                className="estimation-agent-quick-v3__file-tile-pdf-foot"
                onClick={() => {
                  window.open(url, "_blank", "noopener,noreferrer")
                }}
              >
                <i
                  className="pi pi-file-pdf estimation-agent-quick-v3__file-tile-pdf-icon"
                  aria-hidden
                />
                <span>PDF</span>
              </button>
            </div>
          )
        }

        return (
          <div
            key={`msg-img-${idx}-${url}`}
            className={clsx(
              "estimation-agent-quick-v3__file-tile",
              "estimation-agent-quick-v3__file-tile--image"
            )}
          >
            <div className="estimation-agent-quick-v3__file-tile-image-wrap">
              <Image
                src={url}
                alt={name}
                preview
                imageClassName="estimation-agent-quick-v3__file-tile-img"
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
